import {useCallback, useId, useRef} from "react";
import {useSidebarEphemeral} from "./Context/SidebarProvider";

const useSidebarOverlay = () => {
  const ref = useRef(null);
  const id = useId();
  const {activeOverlay, setActiveOverlay} = useSidebarEphemeral();

  const isOpen = activeOverlay === id;

  const toggle = useCallback(() => {
    setActiveOverlay((prev) => (prev === id ? undefined : id));
  }, [id, setActiveOverlay]);

  const close = useCallback(() => {
    setActiveOverlay((prev) => (prev === id ? undefined : prev));
  }, [id, setActiveOverlay]);

  return {
    ref,
    isOpen,
    toggle,
    close,
  };
};

export default useSidebarOverlay;
